import { CheckCircleTwoTone, LinkOutlined } from "@ant-design/icons";
import { Button, Drawer, Empty, Modal, Tooltip, Typography } from "antd";
import { LinkWrapper, LoadingListEntityProfile } from "Explore/Components";
import { useRef, useState } from "react";
import styles from "./FacultyEducation.module.scss";
import useAuth from "Hooks/useAuth";
import LoginRequiredSection from "Explore/Components/LoginRequired";
import { encryptObjectToAsterisk } from "Explore/Utils";
const { Paragraph, Text, Link } = Typography;

const QuotationAndCitation = ({ quotation, citationURL }) => {
  return (
    <div>
      <Paragraph>
        <Link href={citationURL} target="_blank" rel="noreferrer">
          <LinkOutlined />
        </Link>
        &nbsp;
        <Text type="secondary" style={{ fontStyle: "italic" }}>
          {quotation}
        </Text>
        <Tooltip title={citationURL}></Tooltip>
      </Paragraph>
    </div>
  );
};
const Education = ({ education: _education, data_source_url, encoded }) => {
  const education = encoded ? encryptObjectToAsterisk(_education) : _education;

  const render = () => {
    return (
      <div className={styles["education"]}>
        <div className={styles["education-info"]}>
          {/* <Tooltip
              title={education.raw.length > 0 ? "Verified" : "Not yet verified"}
            >
              <CheckCircleTwoTone
                twoToneColor={
                  education.raw.length > 0 ? "#52c41a" : "lightgray"
                }
              />
            </Tooltip> */}
          <div className={styles["title"]}>
            <p className={styles["inst-name"]}>{education.institution}</p>
            <p className={styles["sub-title"]}>
              {education.degree && <span>Degree: {education.degree} </span>}
              {education.graduation_year && (
                <span>({education.graduation_year})</span>
              )}
            </p>
          </div>
        </div>
        {/* {education.raw.length > 0 && (
            <QuotationAndCitation
              quotation={`"...` + education.raw.join(". ") + `..."`}
              citationURL={data_source_url}
            />
          )} */}
      </div>
    );
  };
  return encoded ? (
    render()
  ) : (
    <LinkWrapper link={data_source_url} target="_blank" rel="noreferrer" component={render()} />
  );
};
const FacultyEducation = ({ data }) => {
  const { userTypeConfig } = useAuth({
    entityType: "FACULTY",
  });
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalOpenMobile, setIsModalOpenMobile] = useState(false);
  const [minHeight, setMinHeight] = useState(0);
  const isShow = !!userTypeConfig?.ui_components?.experience;

  return (
    <div className={styles["faculty-detail-education"]}>
      {data.data.length > 0 ? (
        <div className={styles["faculty-detail-education-landscape"]}>
          <div className={styles["list-education-title"]}>
            <h2 className={styles["title"]}>Education</h2>
          </div>
          <LoadingListEntityProfile
            isLoading={data.isLoading}
            component={
              <div
                style={{
                  minHeight,
                  position: "relative",
                }}
              >
                {!isShow && (
                  <LoginRequiredSection blur setHeight={setMinHeight} />
                )}
                {data?.data.length > 0 ? (
                  data?.data.slice(0, 3).map((item, index) => {
                    return (
                      <Education
                        education={item}
                        key={index}
                        data_source_url={data.source_url}
                        encoded={!isShow}
                      />
                    );
                  })
                ) : (
                  <Empty description="No Education Found." />
                )}
                {data.data.length > 3 && (
                  <div className={styles["see-more"]}>
                    <p onClick={() => setIsModalOpen(true)}>
                      See {data.data.length - 3} more
                    </p>
                  </div>
                )}
              </div>
            }
            componentNum={3}
            rows={2}
            avatar={true}
          />
          <Modal
            title="List Education"
            open={isModalOpen}
            onOk={() => setIsModalOpen(false)}
            onCancel={() => setIsModalOpen(false)}
            width={"70%"}
            style={{
              top: "50px",
            }}
            zIndex={1002}
          >
            <div style={{ overflowY: "auto", height: "500px" }}>
              {data?.data.map((item, index) => {
                return (
                  <Education
                    education={item}
                    key={index}
                    data_source_url={data.sourceUrl}
                  />
                );
              })}
            </div>
          </Modal>
        </div>
      ) : (
        <div></div>
      )}
      <div className={styles["faculty-detail-education-mobile"]}>
        {data?.data.map((item, index) => {
          return (
            <Education
              education={item}
              key={index}
              data_source_url={data.sourceUrl}
            />
          );
        })}
      </div>
    </div>
  );
};

export default FacultyEducation;
